import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Container, Row, Col } from 'reactstrap';
import { StyleSheet, css } from 'aphrodite';
// import LogoMubit from '../../assets/images/logo_mubit_azul_2.png'

import SinPlazosForzososPNG from '../../../assets/images/2023/sin_plazos.png'
// import SinPlazosForzososWEBP from '../../assets/images/gracias-express/sin_plazos.webp'

import SinDepositosPNG from '../../../assets/images/2023/sin_depositos.png'
// import SinDepositosWEBP from '../../assets/images/gracias-express/sin_depositos.webp'


import SinCargosPNG from '../../../assets/images/2023/sin_cargos.png'
import { isMobile } from 'mobile-device-detect';
// import SinCargosWEBP from '../../assets/images/gracias-express/sin_cargos.webp'



const styles = StyleSheet.create({
    container: {
        '@media (min-height: 800px)': {
            height: '90vh'
        }

    },
    button: {
        outline: '1px solid #06a77d',
        backgroundColor: '#06a77d',
        color: 'white',
        padding: '10px 30px',
        fontWeight: '700',
        fontSize: '20px',
        cursor: 'pointer',
        marginTop: '20px',
        border: 'none',
        borderRadius: 0,
        margin: '0 50px'
    },
    whats: {
        outline: '1px solid #06a77d',
        backgroundColor: '#0ba139',
        color: 'white',
        padding: '5px 20px',
        fontWeight: '700',
        cursor: 'pointer',
        borderRadius: '10',
        border: 'none'
    },
    icon: {
        fontSize: '22px'
    },
    title: {
        color: '#124a86',
        fontWeight: '600',
        marginBottom: '0',
        fontSize: isMobile ? '20px' : '28px',
        textAlign: 'center'
    },
    titleM: {
        color: '#124a86',
        fontWeight: '900',
        marginBottom: '10px',
        fontSize: isMobile ? '28px' : '28px',
        textAlign: 'center',
        fontFamily: "GothamBold",
    },
    subtitle: {
        fontSize: isMobile ? '14px' : '18px',
    },
    logo: {
        paddingBottom: '2rem',
        maxWidth: '30%'
    },
    list: {
        fontWeight: '900',
        fontSize: '22px',
        textAlign: 'center'
        // padding: '10px 25%'
    },
    bgWhite: {
        backgroundColor: 'white',
        borderRadius: '20px',
        padding: '10px 30px',
        margin: '10px',
        fontSize: '18px'
    },
    bgWhiteImage: {
        backgroundColor: 'white',
        borderRadius: '20px',
        fontSize: '18px',
        padding: '10px',
        height: isMobile ? 'auto' : '60vh',
        width: '100%',
        gridColumn: 'auto / span 1'
        // margin: '10px'
    },
    imageContainer: {
        display: 'grid',
        gridTemplateColumns: isMobile ? 'repeat(1, 1fr)' : 'repeat(3, 1fr)',
        gridGap: '30px',
        padding: isMobile ? '10px' : ''
    }
});

function mapStateToProps(state) {
    return {

    };
}

class GraciasV2 extends Component {

    constructor(props) {
        super(props)
        // window.gtag('event', 'conversion', { 'send_to': 'AW-749049173/9lsUCO6N3oIDENWqluUC' });
    }

    componentWillUpdate({ location, history }) {

    }

    openWhatsapp = () => {
        window.fbq('track', 'Whatsapp');
        window.mixpanel.track('Clic', {
            'on': 'Gracias Express Whatsapp'
        })
        // EVENTOS PARA LA MEDICION DE ADVIEW
        // console.log('GTAG',window.gtag('event', 'click', {'event_category': 'telefono','event_label': 'WA LANDING GRACIAS'}))
        // window.gtag('event', 'click', { 'event_category': 'telefono', 'event_label': 'WA LANDING GRACIAS' });
        // FIN EVENTOS PARA LA MEDICION DE ADVIEW

        window.open("https://wa.me/5213320192861?text=Hola, me gustaría conocer más de su servicio de bodega", '_blank');

    }

    render() {
        return (
            <Container >
                <Row className={css(styles.container) + " d-flex justify-content-center align-items-start py-3"}>

                    <Col md={12} s={12} className={css(!isMobile ? styles.bgWhite : '') + " d-flex flex-column justify-content-center align-items-center  p-3"}>
                        {/* <img className={css(styles.logo)} src={LogoMubit} alt="" /> */}
                        {/* <h1 className={css(styles.title)}>GRACIAS POR TU REGISTRO</h1> */}

                        {isMobile && <>
                            <p className={css(styles.titleM)}>Gracias por su registro</p>
                        </>}

                        <p className={css(styles.title)}>En unos momentos nos pondremos en contacto contigo.</p>

                        <p className={css(styles.subtitle)}>
                            Mientras tanto, puedes conocer más sobre <a href='https://www.home.mubit.co/nosotros'>nosotros</a>.
                        </p>


                        {/* {false &&
                            <picture>
                                <source srcSet={BodegaMobileWEBP} type='image/webp' />
                                <img className='img-fluid' src={BodegaMobilePNG} alt="" />
                            </picture>
                        }
                        {false &&
                            <picture>
                                <source srcSet={BodegaDesktopWEBP} type='image/webp' />
                                <img className='img-fluid' src={BodegaDesktopPNG} alt="" />
                            </picture>
                        } */}
                    </Col>

                    <div className={css(styles.imageContainer)}>

                        <div className={css(styles.bgWhiteImage) + ' d-flex flex-column justify-content-between align-items-center  p-3'} md={4} s={12}>
                            <picture>
                                {/* <source srcSet={SinPlazosForzososWEBP} type='image/webp' /> */}
                                <img className='img-fluid' src={SinPlazosForzososPNG} alt="" />
                            </picture>
                            <p className={css(styles.list)}>
                                Sin plazos forzosos
                            </p>
                        </div>
                        <div className={css(styles.bgWhiteImage) + ' d-flex flex-column justify-content-between align-items-center  p-3'} md={4} s={12}>
                            <picture>
                                {/* <source srcSet={SinDepositosWEBP} type='image/webp' /> */}
                                <img className='img-fluid' src={SinDepositosPNG} alt="" />
                            </picture>
                            <p className={css(styles.list)}>
                                Sin depósitos, ni garantias
                            </p>
                        </div>
                        <div className={css(styles.bgWhiteImage) + ' d-flex flex-column justify-content-between align-items-center  p-3'} md={4} s={12}>
                            <picture>
                                {/* <source srcSet={SinCargosWEBP} type='image/webp' /> */}
                                <img className='img-fluid' src={SinCargosPNG} alt="" />
                            </picture>
                            <p className={css(styles.list)}>
                                Sin cargos sorpresa, paga solo por los metros cuadrados que necesites
                            </p>
                        </div>
                    </div>
                </Row>
            </Container>
        );
    }
}

export default connect(
    mapStateToProps,
)(GraciasV2);